import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;
//axios.defaults.headers.common.Authorization = `Bearer ${}`;

export const Catalogs = createAsyncThunk(
  "catalogs/getCatalogs",
  async (params, { rejectWithValue }) => {
    try {
      const roleList = { 1: "Admin", 2: "Agent", 3: "Customer" };
      params = {
        userType: roleList[localStorage.getItem("userType")] || "Customer",
      };
      const response = await axios.post(`${BASE_URL}/CatalogsGuest/`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
